import { render, staticRenderFns } from "./BoxCard.vue?vue&type=template&id=2579d2cc&scoped=true&"
import script from "./BoxCard.vue?vue&type=script&lang=js&"
export * from "./BoxCard.vue?vue&type=script&lang=js&"
import style0 from "./BoxCard.vue?vue&type=style&index=0&id=2579d2cc&prod&lang=scss&scoped=true&"
import style1 from "./BoxCard.vue?vue&type=style&index=1&id=2579d2cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579d2cc",
  null
  
)

export default component.exports